import React from 'react'
import { IconMaps } from '@ow/icons'
import { Checkbox, Tooltip } from '@mantine/core'

// 勾选框公共样式组件
// tipLabel：提示内容 ，otherProps：为 CheckBox 组件的属性
const CheckComp = ({
  children,
  tipLabel,
  register,
  registerName,
  ...otherProps
}) => {
  return (
    <div className="flex items-center h-8">
      <Checkbox {...register(registerName)} {...otherProps} />
      {tipLabel && (
        <Tooltip
          wrapLines
          width={200}
          withArrow
          transition="fade"
          multiline
          transitionDuration={200}
          label={tipLabel}
        >
          <div>
            <IconMaps type="whiteBgHelp" />
          </div>
        </Tooltip>
      )}
      {children}
    </div>
  )
}

export default CheckComp
